// extracted by mini-css-extract-plugin
module.exports = {"expandable-questions":"styles-module__expandable-questions___2GQjX"};